const RingWarranty = ({ ...props }) => {
  return (
    <svg
      width="21"
      height="24"
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.6212 1H0.594727V24H19.6212V1Z"
        stroke="currentColor"
        strokeWidth="0.772948"
      />
      <path
        d="M4.16211 4.56836H9.81058"
        stroke="currentColor"
        strokeWidth="0.772948"
      />
      <path
        d="M4.16211 6.05469H9.81058"
        stroke="currentColor"
        strokeWidth="0.772948"
      />
      <mask
        id="mask0_623_1528"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="7"
        width="19"
        height="16"
      >
        <rect
          x="1.18945"
          y="7.54102"
          width="17.8373"
          height="15.459"
          fill="currentColor"
        />
      </mask>
      <g mask="url(#mask0_623_1528)">
        <path
          d="M13.388 14.1612C13.4465 14.0184 13.479 13.8624 13.479 13.6989C13.479 13.2894 13.2765 12.9265 12.9667 12.7044C13.0587 12.6228 13.1413 12.5291 13.2113 12.424L13.7927 11.5508C14.0561 11.155 14.0561 10.6437 13.7927 10.248L13.2113 9.37474C12.9435 8.97257 12.4951 8.73242 12.012 8.73242H8.2057C7.72254 8.73242 7.27422 8.97257 7.00643 9.37474L6.42507 10.248C6.16166 10.6437 6.16166 11.155 6.42507 11.5508L7.00647 12.424C7.07644 12.5291 7.15901 12.6228 7.25107 12.7044C6.94123 12.9266 6.73881 13.2894 6.73881 13.6989C6.73881 14.3734 7.28753 14.922 7.96197 14.922H12.2558C12.5487 14.922 12.8177 14.8185 13.0285 14.6462C15.5968 15.7974 17.2477 18.3383 17.2477 21.1626C17.2477 25.099 14.0452 28.3015 10.1089 28.3015C6.17249 28.3015 2.96997 25.099 2.96997 21.1626C2.96997 19.9219 3.29304 18.7001 3.90429 17.6292C4.49734 16.5902 5.3494 15.709 6.36845 15.0809C6.50729 14.9953 6.55048 14.8134 6.46488 14.6745C6.37928 14.5357 6.19737 14.4925 6.05854 14.5781C4.95554 15.258 4.03324 16.2118 3.39136 17.3365C2.72931 18.4964 2.37939 19.8195 2.37939 21.1627C2.37936 25.4247 5.84678 28.8921 10.1089 28.8921C14.3709 28.8921 17.8384 25.4247 17.8384 21.1626C17.8384 18.1481 16.1012 15.4317 13.388 14.1612ZM12.7717 12.0184L12.5354 11.7098C12.4362 11.5804 12.2508 11.5558 12.1214 11.6549C11.9919 11.7542 11.9673 11.9395 12.0665 12.069L12.3306 12.4136C12.2308 12.4539 12.123 12.4757 12.012 12.4757H10.707L11.6883 11.1947H13.3186C13.313 11.2043 12.7717 12.0184 12.7717 12.0184ZM9.27334 11.1947H10.9444L10.1089 12.2854L9.27334 11.1947ZM9.51064 12.4757H8.2057C8.09462 12.4757 7.98682 12.4539 7.88712 12.4137L8.67512 11.385L9.51064 12.4757ZM13.3186 10.604H12.1408L12.7717 9.78037C12.7717 9.78037 13.3129 10.5944 13.3186 10.604ZM12.012 9.32304C12.1231 9.32304 12.2309 9.34477 12.3306 9.38505L11.5426 10.4137L10.7071 9.32304H12.012ZM10.9444 10.604H9.27334L10.1089 9.51333L10.9444 10.604ZM8.2057 9.32304H9.51064L8.67512 10.4137L7.88712 9.38505C7.98686 9.34477 8.09466 9.32304 8.2057 9.32304ZM7.44597 9.78037L8.07695 10.6041H6.8991C6.90477 10.5944 7.44597 9.78037 7.44597 9.78037ZM6.89902 11.1947H8.07691L7.44593 12.0184C7.44593 12.0184 6.90473 11.2043 6.89902 11.1947ZM12.2557 14.3314H7.96197C7.61319 14.3314 7.32942 14.0476 7.32942 13.6989C7.32942 13.3501 7.61319 13.0663 7.96197 13.0663H12.2558C12.6046 13.0663 12.8883 13.3501 12.8883 13.6989C12.8883 14.0476 12.6046 14.3314 12.2557 14.3314Z"
          fill="currentColor"
        />
        <path
          d="M15.1049 18.2987C15.0236 18.1573 14.8431 18.1087 14.7016 18.19C14.5603 18.2713 14.5116 18.4518 14.5929 18.5932C15.0411 19.3722 15.278 20.2609 15.278 21.163C15.2781 24.0139 12.9587 26.3332 10.1079 26.3332C7.25709 26.3332 4.93774 24.0139 4.93774 21.163C4.93774 18.3123 7.25709 15.993 10.1079 15.993C11.542 15.993 12.925 16.5988 13.9024 17.655C14.0131 17.7748 14.2 17.782 14.3197 17.6712C14.4394 17.5605 14.4467 17.3736 14.3359 17.2539C13.2472 16.0772 11.7061 15.4023 10.108 15.4023C6.93147 15.4023 4.34717 17.9866 4.34717 21.1631C4.34717 24.3396 6.93143 26.9238 10.1079 26.9238C13.2844 26.9238 15.8687 24.3395 15.8687 21.163C15.8687 20.1577 15.6045 19.1672 15.1049 18.2987Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export default RingWarranty
